import { Box } from '@mui/material';
import type { GetCreditNotesResponse } from '@vy/api-definition';
import type { Currency, IntegrationProviders } from '@vy/types';
import React from 'react';
import { VyEmptyState } from '../../../../components/new-design/data-display/VyEmptyState';
import { VyTable } from '../../../../components/new-design/table/vy-table/VyTable';
import { getCreditNotesTableColumns } from './credit-notes-table-columns';
import { SheetWithPen } from '@vy/ui-design-system';

type CreditNote = GetCreditNotesResponse['creditNotes'][number];

type CustomerCreditNotesTableProps = {
  entries: CreditNote[];
  isLoading: boolean;
  onViewPdf: (creditLedgerId: string) => void;
  customerId: string;
  currency: Currency;
  connectedIntegrations: IntegrationProviders[];
  customerName: string;
  contactEmails: string[];
};

export const CustomerCreditNotesTable: React.FC<CustomerCreditNotesTableProps> = ({
  entries,
  isLoading,
  onViewPdf,
  customerId,
  currency,
  connectedIntegrations,
  customerName,
  contactEmails,
}) => {
  const columns = getCreditNotesTableColumns({
    onViewPdf,
    customerId,
    currency,
    connectedIntegrations,
    customerName,
    contactEmails,
  });

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <VyTable
        tableName="customer-credit-notes"
        columns={columns}
        items={entries}
        itemsCount={entries.length}
        loadingItems={isLoading}
        disableRowSelectionOnClick
        disableColumnMenu
        showPagination={false}
        sx={{ padding: 2 }}
        noRowsOverlay={() => (
          <VyEmptyState
            title="No credit notes found"
            description="There are no credit notes for this customer yet."
            icon={<SheetWithPen />}
            titleSx={{
              fontSize: '16px !important',
              fontWeight: 600,
            }}
            descriptionSx={{
              fontSize: '14px !important',
              color: '#7E8796',
            }}
          />
        )}
      />
    </Box>
  );
};
